/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var StoreEvents = {
        fetchBag: 'store.fetchBag',
        addToCart: 'store.addToCart',
        categoryNavInit: 'store.categoryNavInit'
    };
    MoyaEventHandler.on(StoreEvents.fetchBag, function (e) {
        site.svg.init();
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
